<script lang="ts">
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';
	import { createViewController, ViewController } from '$lib/actions/animations/ViewController';
	import type { BreakerBlockType } from './BreakerBlockQuery';
	const { data }: { data: BreakerBlockType } = $props();

	createViewController();
</script>

<section use:ViewController>
	{#if data.headline}
		<h2 class="text:headline-large" use:EnterOnView>{data.headline}</h2>
	{/if}
	{#if data.description}
		<p class="text:description-large" use:EnterOnView={{ delay: 0.1 }}>{data.description}</p>
	{/if}
</section>

<style lang="scss">
	section {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;

		@include pagePadding;
		@include blockPadding;
	}

	h2 {
		width: 100%;
		max-width: 680px;
	}

	p {
		text-align: center;
		max-width: 726px;
	}

	p:not(:first-child) {
		margin-top: 38px;
	}
</style>
